var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusDeclined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E70202",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 15.3333L12 13.6667M12 13.6667L13.6667 12M12 13.6667L10.3333 12M12 13.6667L13.6667 15.3333M13.6667 4.08332V5.46668C13.6667 6.58679 13.6667 7.14684 13.8847 7.57466C14.0764 7.95099 14.3824 8.25695 14.7587 8.44869C15.1865 8.66668 15.7466 8.66668 16.8667 8.66668H18.25M18.6667 10.7796V13.6667C18.6667 15.2166 18.6667 15.9916 18.4963 16.6274C18.034 18.3529 16.6862 19.7006 14.9608 20.163C14.3249 20.3333 13.55 20.3333 12 20.3333V20.3333C10.45 20.3333 9.67507 20.3333 9.03924 20.163C7.31378 19.7006 5.96604 18.3529 5.5037 16.6274C5.33333 15.9916 5.33333 15.2166 5.33333 13.6667V10.1485C5.33333 8.7709 5.33333 8.08211 5.46817 7.51332C5.90424 5.67383 7.3405 4.23756 9.18 3.80149C9.74879 3.66666 10.4376 3.66666 11.8151 3.66666V3.66666C12.4185 3.66666 12.7202 3.66666 13.0095 3.70048C13.9302 3.80812 14.8029 4.16958 15.53 4.7445C15.7585 4.92516 15.9718 5.13848 16.3985 5.56513L16.5833 5.74999C17.1919 6.35859 17.4962 6.66289 17.7377 7.00146C18.1784 7.61951 18.4726 8.32979 18.598 9.07844C18.6667 9.48856 18.6667 9.91891 18.6667 10.7796Z",
    stroke: "#E70202",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDeclined);
export default __webpack_public_path__ + "static/media/status-declined.1a27d06de574dc33f1c465b60e00935e.svg";
export { ForwardRef as ReactComponent };